import baseUrl from "../../../utils/api";
import merge from 'webpack-merge';

const baseApi = `${baseUrl}/api/course/commodities/orders?order[updated_at]=desc&equal[school_id]=`;

export default {
  name: "myOrder",
  inject: ['reload'],
  data() {
    return {
      loading: false,
      school: {},

      dialogCheck: { // 支付确认 - 未支付
        data: {
          recharge: {}
        },
        watch: null, // 监听支付结果
        show: false
      },
      dialogsuccess: false, // 支付确认 - 支付成功

      dialogDetail: { // 查看详情
        show: false,
        data: {
          commodities: {
            make_school: {}
          },
          user: {}
        }
      },

      tabs: {
        active: 'all',
        list: [
          {
            label: '全部',
            name: 'all',
            status: '',
            api: '',
            list: {}
          },
          {
            label: '已支付',
            name: 'hasPay',
            status: '&equal[status]=2',
            api: '',
            list: {}
          },
          {
            label: '待支付',
            name: 'noPay',
            status: '&equal[status]=1',
            api: '',
            list: {}
          },
          {
            label: '已取消',
            name: 'hasCancel',
            status: '&equal[status]=4',
            api: '',
            list: {}
          },
          {
            label: '已耗完',
            name: 'hasOut',
            status: '&equal[status]=3',
            api: '',
            list: {}
          },
        ]
      },

      columns: [
        {
          prop: 'commodities.name',
          label: '商品名称',
          formatter: row => row.commodities ? row.commodities.name : '--',
        },
        {prop: 'code', label: '订单号'},
        {prop: 'created_at', label: '创建时间'},
        {prop: 'user.mobile', label: '创建账户'},
        {prop: 'discount_coin', label: '金币数'},
        {prop: 'status_text', label: '状态', hide: true},
      ],

      columnsCancel: [
        {
          prop: 'commodities.name',
          label: '商品名称',
          formatter: row => row.commodities ? row.commodities.name : '--',
        },
        {prop: 'code', label: '订单号'},
        {prop: 'cancelled_at', label: '取消时间'},
        {prop: 'user.mobile', label: '创建账户'},
        {prop: 'discount_coin', label: '返回金币'},
        {prop: 'status_text', label: '状态', hide: true},
      ],
    }
  },
  created () {
    const _id = localStorage.getItem('school_id') || this.choicesSchool.id;

    this.$store.state.school.forEach(val => {
      val.id == _id && (this.school = val);
    });

    this.tabs.list.forEach(val => {
      val.api = `${baseUrl}/api/course/commodities/orders?order[updated_at]=desc&equal[school_id]=${this.school.id}${val.status}`
    });
  },
  methods: {
    handleClick () {
      this.$router.push({
        query: merge(this.$route.query, { page: 1, per_page: 10 })
      })
    },

    // 查看详情
    showDetail (_id) {
      this.loading = true;

      this.$http.get(`${baseUrl}/api/course/commodities/orders/${_id}`).then(res => {
        this.dialogDetail.data = res.data;
        !this.dialogDetail.data.commodities && (this.dialogDetail.data.commodities = {});
        this.dialogDetail.show = true;
      }).finally(() => {
        this.loading = false;
      });
    },

    // 课程 - 购买
    classBuy (row) {
      this.loading = true;

      this.$http.patch(`${this.$checkHttp() + this.school.domain}/api/course/commodities/orders/${row.id}`, {
        status: 2,
      }).then(res => {
        const _data2 = res.data;

        if (_data2.status == 1) {
          // 未支付
          this.dialogCheck.data = _data2;
          this.dialogCheck.show = true;

          this.dialogCheck.watch = setInterval(() => {
            this.watchBuy(_data2.recharge.out_trade_no)
          }, 2e3);
        } else if (_data2.status == 2) {
          // 已支付
          this.dialogsuccess = true;
        }
      })
      .catch(res => this.$message.error(res.message))
      .finally(() => this.loading = false)
    },

    // 监听支付结果
    watchBuy (out_trade_no) {
      this.$http.get(`${baseUrl}/api/expense/main/${this.school.main_id}/recharge-query/${out_trade_no}`)
        .then((res) => {
          if (res.data.trade_status === 'success') {
            this.dialogCheck.show = false;
            this.successDialog = true;
          }
        }).catch(res => {
          console.log(res);
        // this.watchClear();
        // this.$message.error('请求异常! 可在"我的课程"查看结果');
      })
    },

    // 清楚监听
    watchClear () {
      if (this.dialogCheck.watch) {
        clearInterval(this.dialogCheck.watch);
        this.dialogCheck.watch = null;
      }
    },

    // 取消订单
    confirmCancel (_id) {
      this.$confirm('是否要取消订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.patch(`${this.$checkHttp() + this.school.domain}/api/course/commodities/orders/${_id}`, {
            status: 4
        }).then(res => {
          this.$message.success('订单取消成功');
          // this.reload();
          const _tabs = this.tabs.active;
          this.tabs.active = '';
          requestAnimationFrame(() => {
            this.tabs.active = _tabs;
          })
        }).finally(() => {
          this.loading = false;
        }).catch(err=>{
          this.$message.error(err.message);
        })
      }).catch();
    },

    searchCall(arr) {
      if (!arr.length) {
        this.$router.push({
          query: {
            page: 1
          }
        })
        this.reload();
        return;
      }

      this.loading = true;

      this.$http.get(`${baseUrl}/api/course/commodities?${arr.join('&').replace(/\:/g, '=')}`).then(res => {
        let _tab;

        for (let i = 0; i < this.tabs.list.length; i++) {
          if (this.tabs.list[i].name === this.tabs.active) {
            _tab = this.tabs.list[i];
            break;
          }
        }

        if (res.items.length) {
          const _arr = [];

          res.items.forEach(val => _arr.push(`in[commodities_id][]=${val.id}`));

          this.$http.get(`${_tab.api}${/\?/.test(_tab.api) ? '&' : '?'}${_arr.join('&')}`).then(res => {
            _tab.list = res;
          }).finally(() => {
            this.loading = false;
          })
        } else {
          _tab.list = {
            items: []
          };
          this.loading = false;
        }
      }).catch(() => {
        this.loading = false;
      })
    },

    goClass(row) {
      this.$router.push({
        path: '/myClass/classDetail',
        query: {
          id: row.id,
          code: row.code,
          from: 'order',
          commodities_id: row.commodities_id,
          offline_left: row.offline_left,
          online_left: row.online_left,
        }
      })
    },

    // 去支付
    getCover () {
      window.open(this.dialogCheck.data.recharge.code_img_url);
    },
  },

  computed: {
    searchArr() {
      return [
        {
          componentType: 'AppSearchColumn',
          searchType: 'name',
          placeholder: '搜索商品名称'
        },
      ];
    },
    choicesSchool() {
      return this.$store.state.choicesSchool
    }
  },

  beforeDestroy () {
    this.watchClear();
  }
}



// WEBPACK FOOTER //
// ./src/views/MyClass/MyOrder/index.js